import { environmentStore } from '@/react/hooks/current-environment-store';
import { queryClient } from '@/react-tools/react-query';
import { Environment } from '@/react/portainer/environments/types';
import { environmentQueryKeys } from '@/react/portainer/environments/queries/query-keys';

import { TypedPolicy } from '../../types';
import { getChangeConfirmationPolicyData } from '../../components/change-confirmation/types';
import { queryKeys as policyQueryKeys } from '../../queries/query-keys';

/**
 * Gets the change confirmation policy from the cache using the existing query cache without needing a hook (e.g. for angular or function calls)
 */
export function getChangeConfirmationPolicyFromCache() {
  const { environmentId, isInEnvironmentRoute } = environmentStore.getState();
  if (!environmentId || !isInEnvironmentRoute) {
    return null;
  }

  const environment = queryClient.getQueryData<Environment>(
    environmentQueryKeys.item(environmentId)
  );
  if (!environment) {
    return null;
  }

  const policyId = environment.Policies?.changeConfirmationPolicy?.policyID;
  if (!policyId) {
    return null;
  }

  const policyEntry = queryClient.getQueryData<TypedPolicy<unknown>>(
    policyQueryKeys.detail(policyId)
  );

  return getChangeConfirmationPolicyData(policyEntry?.Data);
}
